
export enum TextureDimension {
    Tex2D,
    Cube,
    Tex3D,
    Texture2DArray,
    CubeArray,
    Unkonw,
    None
}